<template>
  <base-section id="pro-features" v-if="btnHtml">
    <base-section-heading :title="$i18n.t(heading)">
      <p v-html="btnHtml"></p>
    </base-section-heading>
  </base-section>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  transDetail = {};
  heading = "Payment";
  btnHtml = null;

  async getPaymentLinks(trans_id) {
    const url = "/api/o/payment/trans/get/links";
    const map = { trans_key: trans_id };
    try {
      common.setLoading(true);
      const response = await doPost(url, map);
      this.transDetail = response.detail;
      if (this.transDetail.purpose === "BOOKING_PYMT") {
        this.heading = "Booking Payment";
      } else if (this.transDetail.purpose === "CART_PYMT") {
        this.heading = "Cart Payment";
      } else if (this.transDetail.purpose === "INVOICE_PYMT") {
        this.heading =
          "Invoice " +
          (response.invoiceNo ? response.invoiceNo + " " : "") +
          "Payment";
      } else {
        this.heading = "Payment";
      }
      let buttons = "";
      for (let i = 0; i < response.links.length; i++) {
        buttons = buttons + response.links[i].link;
        if (response.links[i].charge && response.links[i].charge.amount) {
          buttons =
            buttons +
            '<div style="text-align:center;">' +
            response.links[i].charge.name +
            ": " +
            (response.links[i].charge.isAbs
              ? this.transDetail.currency + " "
              : "") +
            response.links[i].charge.amount +
            (response.links[i].charge.isAbs ? "" : "%") +
            // + ' (' + (response.links[i].charge.finalAmount ? '   ' + response.links[i].charge.currency + ' ' + response.links[i].charge.finalAmount : '') + ')'
            "</div><br>";
        } else {
          buttons = buttons + "<br>";
        }
      }
      // window.addEventListener("beforeunload", this.beforeLeave, false);
      this.btnHtml = buttons;

      // setTimeout(function () {
      //   $(".paymentButton").each(function () {
      //     $(this).on("click", function (e) {
      //       window.removeEventListener("beforeunload", this.beforeLeave, false);
      //     });
      //   });
      // });
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  beforeLeave(e) {
    // Cancel the event
    e.preventDefault();
    // Chrome requires returnValue to be set
    e.returnValue = "";
  }

  async mounted() {
    this.getPaymentLinks(this.$route.params.id);
  }
}
</script>